export class ProductUseMetric {
	day: ProductUseIntervalMetric[];
	week: ProductUseIntervalMetric[];
	month: ProductUseIntervalMetric[];
	data: ProductUseIntervalMetric[];

	public constructor(init?: Partial<ProductUseMetric>) {
		Object.assign(this, init);
	}
}

export class ProductUseIntervalMetric {
	date?: string;
	visits: number = 0;
	product: string;
	abandons: number = 0;
	completes: number = 0;
	mobile: number = 0;
	desktop: number = 0;
	states: string[] = [];
	cities: string[] = [];

	public constructor(init?: Partial<ProductUseIntervalMetric>) {
		Object.assign(this, init);
	}
}
